import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f01b9a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderReceiversListItem" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-blue-600 font-semibold" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-x-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6 pb-3" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "text-blue-600 font-semibold" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6 border-t pt-3" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Примечания к отправке:", -1))
const _hoisted_26 = { class: "block text-sm text-gray-400 font-semibold" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down mr-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-up mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.is_opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.receiver.title), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.full_name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.phone), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.full_address), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, "Мест: " + _toDisplayString(_ctx.receiver.places), 1),
                _createElementVNode("span", null, "Вес: " + _toDisplayString(_ctx.receiver.weight) + " кг", 1),
                _createElementVNode("span", null, [
                  _createTextVNode("Объём: " + _toDisplayString(_ctx.receiver.volume) + " м", 1),
                  _hoisted_9
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.receiver.shipment_type), 1)
              ])
            ]),
            _hoisted_10
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.receiver.title), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.full_name), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.phone), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.full_address), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, "Мест: " + _toDisplayString(_ctx.receiver.places), 1),
              _createElementVNode("span", null, "Вес: " + _toDisplayString(_ctx.receiver.weight) + " кг", 1),
              _createElementVNode("span", null, [
                _createTextVNode("Объём: " + _toDisplayString(_ctx.receiver.volume) + " м", 1),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, " Тип доставки: " + _toDisplayString(_ctx.receiver.shipment_type), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.payment_type), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.receiver.payment_method), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, [
                _createTextVNode(" Номер накладной заказчика: "),
                (Boolean(_ctx.receiver.dop_invoice_number))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.receiver.dop_invoice_number), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ]),
              _createElementVNode("span", null, [
                _createTextVNode(" Возвратные документы: "),
                (Boolean(_ctx.receiver.should_return_document))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Да ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Нет")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, "Длина: " + _toDisplayString(_ctx.receiver.depth), 1),
              _createElementVNode("span", null, "Ширина: " + _toDisplayString(_ctx.receiver.width), 1),
              _createElementVNode("span", null, "Высота: " + _toDisplayString(_ctx.receiver.height), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (Boolean(_ctx.receiver.cod_payment))
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Наложенный платёж: " + _toDisplayString(_ctx.receiver.cod_payment), 1))
                : _createCommentVNode("", true),
              (Boolean(_ctx.receiver.declared_price))
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Объявленная стоимость: " + _toDisplayString(_ctx.receiver.declared_price), 1))
                : _createCommentVNode("", true),
              (Boolean(_ctx.receiver.annotation))
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", null, _toDisplayString(_ctx.receiver.annotation), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center justify-between", { 'mt-3': _ctx.state.is_opened }])
    }, [
      _createElementVNode("span", _hoisted_26, "№" + _toDisplayString(_ctx.index + 1), 1),
      _createElementVNode("div", _hoisted_27, [
        (!_ctx.withoutUpdate)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: "primary text small mr-3",
              disabled: _ctx.disabled,
              onClick: _ctx.emitUpdate
            }, {
              default: _withCtx(() => [
                _hoisted_28,
                _createTextVNode(" Редактировать ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.state.is_opened)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "primary small text",
              onClick: _ctx.open
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _createTextVNode(" Раскрыть ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 2,
              class: "primary small text",
              onClick: _ctx.close
            }, {
              default: _withCtx(() => [
                _hoisted_30,
                _createTextVNode(" Скрыть ")
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ], 2)
  ]))
}